var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "8px",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "path9429 Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header01",
    transform: "translate(-1246.000000, -42.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1249.28077,40.8096853 C1248.95507,40.8025421 1248.66059,41.0024656 1248.54713,41.3078628 C1248.43367,41.6132599 1248.52615,41.9570191 1248.77752,42.1641741 L1253.45611,46.1722579 L1248.77752,50.178843 C1248.54625,50.3487818 1248.4296,50.6338957 1248.47544,50.9172461 C1248.52127,51.2005073 1248.72188,51.4342956 1248.99493,51.5226608 C1249.26798,51.6109377 1249.5675,51.5389757 1249.77058,51.3362295 L1255.12714,46.7531561 C1255.29738,46.6079098 1255.39542,46.3953751 1255.39542,46.1715523 C1255.39542,45.9477298 1255.29738,45.7351954 1255.12714,45.5899487 L1249.77058,41.0023774 C1249.63527,40.8821764 1249.46171,40.8138302 1249.28077,40.8095 L1249.28077,40.8096853 Z",
    id: "path9429-Copy-4",
    transform: "translate(1251.930511, 46.184638) rotate(90.000000) translate(-1251.930511, -46.184638) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.aa0e7fef35a66ad62210c5215e9c58b9.svg";
export { ForwardRef as ReactComponent };